import moment from 'moment';

const CommandHistoryComponent = {
  template: require('./history.html'),
  restrict: 'E',
  bindings: {
    history: '<',
    updating: '<',
    loading: '<'
  },
  controller: CommandHistoryController,
  controllerAs: 'vm'
};

function CommandHistoryController ($interval, CommandHistoryService) {
  'ngInject';

  const vm = this;
  let interval;

  vm.history = [];
  vm.progressPercent = '0%';
  vm.progressMessage = '';
  vm.messageFlage = false;
  vm.start = vm.end = moment().toDate();
  vm.classes = {
    pending: 'fa fa-spinner fa-pulse fa-md pending',
    completed: 'fa fa-check succeeded-icon fa-md success',
    aborted: 'fa fa-times failed-icon fa-md error',
    rejected: 'fa fa-times failed-icon fa-md error'
  };

  const updatePending = () => {
    if (!vm.updating && vm.history) {
      CommandHistoryService.updatePending(vm.history);
    }
  };
  
  vm.$onInit = () => {
    vm.status = CommandHistoryService.commandHistoryStatus;

    interval = $interval(() => {
      updatePending();
    }, 15000);
  };

  vm.$onDestroy = () => {
    $interval.cancel(interval);
  };
}

export default CommandHistoryComponent;
